
import axios from "axios";
import { API_BASE } from "../config";

export const GetAction = (method,data,url)=> {
    axios.defaults.baseURL = API_BASE;
    
    return new Promise((resolve) =>{
        axios.get(url,{
            params:data
        })
        .then((res) =>{
            resolve(res.data)
        })
        .catch((err) =>{
            resolve(err?.response?.data || { status: 'failed', response: null })
        })
  
    }
  )
}
